import React from 'react';
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { useLabels } from 'components/general/Label';
import Sprites from "styles/images/Spritemedals.svg";
import Spritemedals_de from "styles/OG2024/images/medals/Spritemedals_de.svg"
import Spritemedals_en from "styles/OG2024/images/medals/Spritemedals_en.svg"
import Spritemedals_es from "styles/OG2024/images/medals/Spritemedals_es.svg"
import Spritemedals_fr from "styles/OG2024/images/medals/Spritemedals_fr.svg"
import Spritemedals_hi from "styles/OG2024/images/medals/Spritemedals_hi.svg"
import Spritemedals_it from "styles/OG2024/images/medals/Spritemedals_it.svg"
import Spritemedals_ja from "styles/OG2024/images/medals/Spritemedals_ja.svg"
import Spritemedals_ko from "styles/OG2024/images/medals/Spritemedals_ko.svg"
import Spritemedals_pt from "styles/OG2024/images/medals/Spritemedals_pt.svg"
import Spritemedals_ru from "styles/OG2024/images/medals/Spritemedals_ru.svg"
import Spritemedals_zh from "styles/OG2024/images/medals/Spritemedals_zh.svg"
import { useGetLanguages } from 'helpers/commonCodes';

export const Medal = ({ code }) => {
    const { mirs_competition } = useUrlFriendlyToParameters()
    if (mirs_competition === "OG2024" || mirs_competition === "PG2024") {
        return <MedalOG2024 code={code} />
    } else {
        return <MedalGeneric code={code} />
    }
}

export const MedalOG2024 = ({ code }) => {
    const { mirs_language } = useUrlFriendlyToParameters()
    const fLabel = useLabels()

    let description = code;
    let medalType = 'silver'
    if (code === "1") {
        medalType = 'gold';
    } else if (code === "2") {
        medalType = 'silver';
    } else if (code === "3") {
        medalType = 'bronze';
    }
    const descCode = "LabelMedalDesc" + code;
    description = fLabel({ data: descCode })

    const dataLanguage = useGetLanguages()
    let language = dataLanguage?.languages?.find(item => item.lang === mirs_language?.toUpperCase())?.langIsoCode
    let Spritemedals

    switch (language?.toLowerCase()) {
        case 'de':
            Spritemedals = Spritemedals_de
            break
        case 'en':
            Spritemedals = Spritemedals_en
            break
        case 'fr':
            Spritemedals = Spritemedals_fr
            break
        case 'es':
            Spritemedals = Spritemedals_es
            break
        case 'hi':
            Spritemedals = Spritemedals_hi
            break
        case 'it':
            Spritemedals = Spritemedals_it
            break
        case 'ja':
            Spritemedals = Spritemedals_ja
            break
        case 'ko':
            Spritemedals = Spritemedals_ko
            break
        case 'pt':
            Spritemedals = Spritemedals_pt
            break
        case 'ru':
            Spritemedals = Spritemedals_ru
            break
        case 'zh':
            Spritemedals = Spritemedals_zh
            break
        default:
            Spritemedals = Spritemedals_en
    }
    return (
        <svg width={20} height={20}>
            <title>{description}</title>
            <use xlinkHref={`${Spritemedals}#${medalType}`} />
        </svg>
    )
};


export const MedalGeneric = ({ code }) => {
    const fLabel = useLabels()
    let description = code;
    let medalType = 'silver'
    if (code === "1") {
        medalType = 'gold';
    } else if (code === "2") {
        medalType = 'silver';
    } else if (code === "3") {
        medalType = 'bronze';
    }
    let descCode = "LabelMedalDesc" + code;
    description = fLabel({ data: descCode })
    let Spritemedals = Sprites
    return (
        <>
            <svg width={20} height={20}>
                <title>{description}</title>
                <use xlinkHref={`${Spritemedals}#${medalType}`} />
            </svg>
        </>

    )
};

//export const MedalMemo = React.memo(Medal);

export default Medal

